module.exports = __webpack_public_path__ + "img/flow_01.e0164006.png";